import React from 'react'
import '../Styles/Counter.css'
import '../Styles/StarAgency.css'
import Introduction from '../Components/Introduction'
import staragency from '../Assets/logo-staragency2.webp'
import Services from '../Components/Services'
import CardServices from '../Components/CardServices'
import MarketAnalysis from '../Components/MarketAnalysis'
import banner from '../Assets/star-agency.webm'
import Counter from '../Components/Counter'

function StarAgency({ id }) {
  return (
    <section id={id}>
      <div id="staragency-introduction">
        <video
          id="banner-background"
          className="video-background"
          autoPlay
          loop
          muted
          playsInline
          loading="lazy"
        >
          <source src={banner} type="video/mp4" />
        </video>
        <Introduction
          srcLogo={staragency}
          altLogo="Star Agency"
          description={
            <>
              A Star Agency se posiciona como uma{' '}
              <span>agência líder no Brasil</span>, especializada em
              reposicionamento digital. Com sede em Florianópolis, a empresa se
              destaca por oferecer um pacote exclusivo de serviços que superam
              as opções tradicionais do mercado, adaptando-se às necessidades
              individuais de cada artista.
            </>
          }
          color="white"
          img={false}
        />
      </div>

      <Counter />

      <Services>
        <CardServices
          title="Lista de Casas de Shows"
          description="Facilitação do acesso a uma vasta lista de espaços para apresentações ao vivo, organizados por estilo musical, com contatos diretos para simplificar a organização de shows."
          colorTitle="white"
          colorContent="white"
          height="200px"
          className="gold-background"
        />
        <CardServices
          title="Diagnóstico de Carreira"
          description="Avaliação abrangente da trajetória e potencial do artista, considerando desde habilidades musicais até estratégias de marketing e presença digital."
          colorTitle="white"
          colorContent="white"
          height="200px"
          className="gold-background"
        />
        <CardServices
          title="Desenvolvimento Artístico"
          description="Oferecemos suporte completo no desenvolvimento de projetos musicais, incluindo branding, marketing digital e elaboração de planos de ação personalizados para promover a carreira."
          colorTitle="white"
          colorContent="white"
          height="200px"
          className="gold-background"
        />
        <CardServices
          title="Soluções Digitais"
          description="Especialização na criação e otimização de sites e redes sociais, visando aumentar a visibilidade e interação com o público."
          colorTitle="white"
          colorContent="white"
          height="200px"
          className="gold-background"
        />
      </Services>

      <MarketAnalysis
        description={
          <>
            <br />
            <br />
            Em uma indústria marcada pela saturação e pela competição acirrada,
            a capacidade da Star Agency de identificar e cultivar nichos
            específicos para seus artistas não apenas aumenta a visibilidade
            destes, mas também assegura uma conexão mais profunda e autêntica
            com o público.
            <br />
            <br /> Além disso, a ênfase da agência na personalização de suas
            estratégias de marketing e no diagnóstico detalhado de carreira
            reflete um entendimento profundo das nuances individuais de cada
            artista, permitindo uma abordagem sob medida que maximiza o
            potencial de sucesso.
            <br />
            <br /> A Star Agency, portanto, não apenas acompanha as tendências
            da indústria musical, mas também antecipa e molda o futuro da gestão
            de carreiras artísticas no Brasil.
          </>
        }
        backgroundColor="#121212"
        colorTitle="white"
        colorContent="white"
        colorSvg="white"
        news="No ano de 2023, o mercado musical brasileiro faturou R$ 2,864 bilhões, um aumento de 13,4% nos últimos 2 anos. (Fonte: Olhar Digital, 2024)"
        backgroundNews="#FFB900"
        colorNews="white"
      />
    </section>
  )
}

export default StarAgency
